<template>
  <div class="pb-2">
    <div class="row">
      <div class="col-12">
        <vue-form-generator
          v-if="!child"
          ref="teamMemberForm"
          :schema="schemaStatus"
          :model="modelform"
          :options="formOptions"
        ></vue-form-generator>
        <vue-form-generator
          v-if="child && !loading"
          ref="teamMemberForm"
          :schema="schemaStatusChild"
          :model="modelformChild"
          :options="formOptions"
        ></vue-form-generator>
      </div>
      <div class="col-12 mt-3 d-flex align-items-center" v-if="child">
        <span class="ml-5">How many teams do you want to create ?</span>
        <div class="col-3">
          <select
            v-model="howManyTeams"
            class="form-control"
            name="teams"
            id="teams"
          >
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
          </select>
        </div>
      </div>
      <div class="col-12 text-center align-center">
        <button
          v-if="!editing"
          class="
                  btn
                  btn-primary
                  mr-3
                  btn-sm
                  mx-1
                  px-3
                  py-2
                  cursor-pointer
                  font-weight-bolder
                  btn-primary"
          type="button"
          @click="newMember"
          :disabled="!validateSpacesInFields"
        >
          <i class="icon-plus"></i> {{ $t("lang.search.add") }}
        </button>
        <button
          v-else
          class="btn
                    btn-primary
                    btn-sm
                    mr-3
                    mb-0
                    mx-1
                    px-3
                    py-2
                    cursor-pointer
                    btn-success"
          type="button"
          @click="newMember"
        >
          {{ $t("lang.button.save") }}
        </button>
      </div>
    </div>

    <div
      class="row justify-content-center mt-4 text-center"
      v-if="alertMessage"
    >
      <AlertError :msgError="alertMessage" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import VueFormGenerator from "vue-form-generator";
import { usersService, monitorService } from "@/_services";
import {
  getTargetingContactsTotal,
  getIdealNumberOfSalesByResult,
  getSalesQuantityBlockReason,
} from "@/_helpers/orderSalesQuantity";
import AlertError from "@/components/AlertError.vue";

export default {
  data() {
    var self = this;
    return {
      loading: true,
      howManyTeams: 1,
      salesRep: [],
      clients: [
        {
          id: 0,
          name: "Select client..."
        }
      ],
      target: {},
      editing: false,
      editingEmail: "",
      alertMessage: "",
      modelform: {
        index: 0,
        first_name: "",
        last_name: "",
        email: "",
        linkedinurl: ""
      },
      schemaStatus: {
        fields: [
          {
            type: "select",
            label: this.$t("lang.label.role"),
            model: "role_id",
            featured: true,
            required: true,
            values: function() {
              if (self.currentUser.role_id == 1 && !self.client_id) {
                return [
                  { id: "1-1", name: "Oliver Operational" },
                  { id: "1-2", name: "Account Manager" },
                  { id: "1-3", name: "Account Executive" },
                  { id: "2-2", name: "Booker" }
                ];
              }
            },
            visible: () => {
              return (
                this.hasPermissions("adminClients") &&
                self.currentUser.role_id == 1 &&
                !self.client_id
              );
            },
            default: "1",
            styleClasses: "col-md-3",
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required")
            })
          },
          {
            type: "vueMultiSelect",
            label: this.$t("lang.label.client"),
            model: "client_id",
            // featured: true,
            selectOptions: {
              multiSelect: false,
              searchable: true,
              showLabels: false,
              trackBy: "id",
              label: "name"
            },
            required: true,
            values: () => {
              return this.clients;
            },
            visible: () => {
              return (
                false &&
                this.hasPermissions("adminClients") &&
                !this.client_id &&
                ["3", "4"].includes(this.modelform.role_id)
              );
            },
            default: "1",
            styleClasses: "col-md-3",
            validator: VueFormGenerator.validators.required
          },

          {
            type: "input",
            inputType: "text",
            model: "first_name",
            placeholder: "ex : Michael",
            featured: true,
            required: true,
            label: this.$t("lang.label.firstname"),
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required")
            }),
            styleClasses: "col-md-3"
          },
          {
            type: "input",
            inputType: "text",
            model: "last_name",
            placeholder: "ex : Platini",
            featured: true,
            required: true,
            label: this.$t("lang.label.lastname"),
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required")
            }),
            styleClasses: "col-md-3"
          },
          {
            type: "input",
            inputType: "email",
            label: "Email",
            model: "email",
            id: "email",
            featured: true,
            required: true,
            placeholder: "ex : michael@gmail.com",
            validator: VueFormGenerator.validators.email.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              invalidEmail: this.$t("lang.validation.email")
            }),
            styleClasses: "col-md-3"
          }
        ]
      },

      modelformChild: {
        index: 0,
        sales_representative_id: []
      },
      schemaStatusChild: {
        fields: [
          {
            type: "vueMultiSelect",
            label: this.$t("lang.label.team"),
            model: "sales_representative_id",
            selectOptions: {
              multiSelect: false,
              searchable: false,
              showLabels: false,
              trackBy: "id",
              label: "label"
            },
            required: true,
            values: () => {
              return this.salesRep;
            },
            default: "1",
            styleClasses: "col-md-12",
            validator: VueFormGenerator.validators.required
          }
        ]
      },

      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true
      },
      hourly: false
    };
  },

  computed: {
    ...mapState({
      currentUser: state => state.authentication.user,
      teamMembers: state => state.onboarding.step3.teamMembers
    }),
    validateSpacesInFields() {
      if (this.$route.name == "clients") {
        return true;
      }
      const regex = /^[A-Za-zÀ-ÿ\s]+$/;

      if (
        this.modelform.first_name.trim().length <= 0 ||
        this.modelform.last_name.trim().length <= 0
      ) {
        return false;
      }
      if (
        !regex.test(this.modelform.first_name) ||
        !regex.test(this.modelform.last_name)
      ) {
        return false;
      }
      return true;
    }
  },

  components: {
    "vue-form-generator": VueFormGenerator.component,
    AlertError
  },

  props: {
    member: Object,
    editingIndex: Number,
    add: {
      type: Boolean,
      default: false
    },
    child: {
      type: Boolean,
      default: false
    },
    clientStatus: {
      type: String,
      default: "0"
    },
    client_id: {
      type: String,
      default: false
    }
  },

  watch: {
    member: function(member) {
      this.modelform.first_name = member.first_name;
      this.modelform.last_name = member.last_name;
      this.modelform.email = member.email;
      this.modelform.linkedinurl = member.linkedinurl;
      this.modelform.index = this.editingIndex;
      this.editing = true;
      this.editingEmail = member.email;
    }
  },
  created() {
    if (this.clientStatus != 0 || !this.client_id) {
      this.getClients();
    }
    if (this.child) {
      this.loading = true;

      if (this.client_id) {
        usersService.getSalesByClient(this.client_id).then(result => {
          result.forEach(item => {
            this.salesRep.push({
              id: item.sales_representative_id,
              label:
                item.first_name + " " + item.last_name + " (" + item.email + ")"
            });
          });
          this.loading = false;
        });
      } else {
        usersService.getSales(999999).then(result => {
          result.forEach(item => {
            this.salesRep.push({
              id: item.sales_representative_id,
              label: item.first_name + " " + item.last_name
            });
          });
          this.loading = false;
        });
      }
    } else {
      this.loading = false;
    }
  },
  mounted() {
    if (this.client_id) {
      this.modelform.client_id = this.client_id;
    }
  },

  methods: {
    ...mapActions("onboarding", {
      addTeamMember: "addTeamMember"
    }),
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    getClients() {
      const toCreateUser = 1;
      monitorService
        .getClients(null, this.clientStatus, toCreateUser)
        .then(res => {
          this.clients = res;
        })
        .catch(err => console.log(err));
    },
    addMember() {
      if (this.add) {
        if (this.hasPermissions("adminClients") && this.modelform.client_id) {
          if (!this.client_id) {
            this.modelform.client_id = this.modelform.client_id.id;
          }
        }
      } else {
        this.addTeamMember(this.modelform);
      }

      if (this.child) {
        if (this.client_id) {
          this.modelformChild.client_id = this.client_id;
        }
        this.modelformChild.howManyTeams = this.howManyTeams;
        this.$emit("newForm", this.modelformChild);
      } else {
        this.$emit("newForm", this.modelform);
      }
    },

    newMember() {
      this.$refs.teamMemberForm.validate();
      if (this.$refs.teamMemberForm.errors.length > 0) {
        return;
      }

      if (!this.child && !this.add && !this.canAddMoreTeamMember()) {
        return;
      }

      if (this.child) {
        this.addMember();
      } else {
        if (this.editingEmail == this.modelform.email) {
          this.addMember();
        } else if (this.mailIsUnique(this.modelform.email) || this.add) {
          usersService.getCheckMail(this.modelform.email).then(res => {
            if (!res) {
              this.addMember();
            } else {
              if (this.add)
                this.alertMessage = this.$t("lang.label.emailalreadyexists");
              else this.showDuplicatedEmailError();
            }
          });
        }
      }
    },

    showDuplicatedEmailError() {
      this.$swal({
        type: "error",
        title: this.$t("lang.label.error"),
        text: this.$t("lang.label.emailalreadyexists"),
        showConfirmButton: false,
        timer: 1900
      });
    },

    canAddMoreTeamMember() {
      const onBoarding = this.$store.state.onboarding;
      const blockReason = getSalesQuantityBlockReason(onBoarding, null, 1);

      if (blockReason) {
        this.$swal({
          type: "warning",
          title: this.$t("lang.label.error"),
          text:
            blockReason === "no_contacts"
              ? this.$t("lang.onBoarding.errorquantitysales_no_contacts", {
                  contacts: getTargetingContactsTotal(onBoarding),
                })
              : this.$t("lang.onBoarding.errorquantitysales", {
                  size: getTargetingContactsTotal(onBoarding),
                  quantity: getIdealNumberOfSalesByResult(
                    getTargetingContactsTotal(onBoarding)
                  ),
                }),
          showConfirmButton: true,
        });
        return false;
      }

      return true;
    },

    mailIsUnique(email) {
      return this.teamMembers.every(teamMember => {
        if (teamMember.email == email) {
          this.showDuplicatedEmailError();
          return false;
        }
        return true;
      });
    }
  }
};
</script>
